'use strict';

module.exports = [function () {
    return {
        replace: true,
        scope: true, 
        template: require('./buttonClose.html')
    };
}];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/buttons/buttonClose.js
// module id = 384
// module chunks = 0